import { languages, withLanguagePath, type LanguageCode } from '../data/languages'

type LanguageSwitcherProps = {
  activeLanguage: LanguageCode
}

export function LanguageSwitcher({ activeLanguage }: LanguageSwitcherProps) {
  return (
    <nav className="language-switcher" aria-label="Dil secimi">
      {languages.map((language) => (
        <a
          aria-current={language.code === activeLanguage ? 'page' : undefined}
          href={withLanguagePath(language.code)}
          key={language.code}
        >
          {language.shortLabel}
        </a>
      ))}
    </nav>
  )
}
